import { parseISO } from 'date-fns';
import { diffInUnit } from '../valueSeries/ticks';

export function getNumPeriods({
    startDate,
    targetDate,
    unit,
    interval = 1,
}: {
    startDate: string;
    targetDate: string;
    unit: 'day' | 'week' | 'month' | 'year';
    interval?: number;
}): number {
    return Math.floor(
        diffInUnit(parseISO(targetDate), parseISO(startDate), unit) / interval
    );
}
